<template>
  <div id="mui-player">
    <!-- <template slot="HD">
      <div
        style="color: white;display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;font-size: 16px;">
        <p onclick="on_hd(1)">蓝光1080P</p>
        <p onclick="on_hd(2)">超清</p>
        <p onclick="on_hd(3)">高清</p>
        <p onclick="on_hd(4)">标清</p>
      </div>
    </template> -->
    <videoQuestion
      ref="videoQuestion"
      @timeInterval="timeIntervalStart"
      :videoQuestionInfo="videoQuestionInfo"
    >
    </videoQuestion>
  </div>
</template>

<script>
import "mui-player/dist/mui-player.min.css";
import MuiPlayerDesktopPlugin from "mui-player-desktop-plugin";
import MuiPlayer from "mui-player";
import { mapState } from "vuex";
import videoQuestion from "./videoQuestion.vue";
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    courseDetail: {},
    courseSettingInfo: {},
  },
  components: {
    videoQuestion,
  },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      iscontinuous: (state) => state.learning.iscontinuous,
      courseChapterList: (state) => state.learning.courseChapterList,
    }),
  },
  watch: {
    src: {
      handler(val) {
        if (val) {
          // console.log(val,9999)
          // let that = this;
          // if(that.mp){
          //   console.log(that.mp.reloadUrl)
          //   that.mp.reloadUrl(val);
          // }
          try {
            if (this.mp) {
              this.mp.reloadUrl(val); // 确保播放器实例存在
            }
          } catch (error) {
            console.error("更新视频源失败:", error);
          }
        }
      },
    },
    selectLearningInfo: {
      handler(val) {
        if (!val?.chapterResource?.chapterId) return;
        // 获取视频弹题数据
        this.getVideoQuestion(
          val.courseId,
          val.schemeId,
          val.roundId,
          val.id,
          val.chapterId
        );
      },
      immediate: true,
      deep: true,
    },
    courseSettingInfo: {
      handler() {
        setTimeout(() => {
          if (this.courseSettingInfo.learningAllowVideoSeek == 0) {
            // 方法1: 不使用 !important
            let videoProgressDom = document.getElementById("progress-container");
            console.log(videoProgressDom, "进度条元素");
            if (videoProgressDom) {
              videoProgressDom.style.display = "none";
            }

            // 方法2: 使用 cssText 设置样式
            if (videoProgressDom) {
              videoProgressDom.style.cssText = "display: none !important";
            }
          }
        }, 1500);
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      plugins: [],
      mp: {},
      definitionCongig: [
        { functions: "蓝光1080P", selected: false, url: "11111" },
        { functions: "超清", selected: false, url: "22222" },
        { functions: "高清", selected: true, url: "33333" },
        { functions: "标清", selected: false, url: "44444" },
      ],
      videoInfo: {},
      timerInterval: "",
      videoQuestionList: [],
      isFirstPlay: true,
      timeIntervalRecord: "",
      stageStartTime: 0,
      lastVideoTime: 0,
      videoQuestionInfo: {}, // 弹题对象（包含题目列表）
      watchedLastAt: 0, // 上次视频观看进度
    };
  },
  mounted() {
    this.mp = new MuiPlayer({
      container: "#mui-player",
      title: this.title,
      src: this.src,
      preload: "auto", // 关键配置：强制完全预加载
      // width:762,
      height: 450, // 高度
      autoFit: false, // 是否自适应高度
      objectFit: "cover", // cover全覆盖容器
      videoAttribute: [
        { attrKey: "webkit-playsinline", attrValue: "" },
        { attrKey: "playsinline", attrValue: "" },
        { attrKey: "x5-playsinline", attrValue: "" },
        { attrKey: "t7-video-player-type", attrValue: "inline" },
        { attrKey: "x5-video-player-type", attrValue: "h5-page" },
        { attrKey: "x-webkit-airplay", attrValue: "allow" },
        { attrKey: "controlslist", attrValue: "nodownload" },
      ],
      plugins: [
        typeof MuiPlayerDesktopPlugin == "function"
          ? new MuiPlayerDesktopPlugin({
              // thumbnails: { // 缩略图配置
              //   preview: ['https://muiplayer.oss-cn-shanghai.aliyuncs.com/static/image/output_160x90_10x10_001.jpg'],
              //   tile: [10, 10],
              //   scale: [160, 90],
              // },
              customSetting: [
                {
                  functions: "清晰度",
                  model: "select",
                  show: true,
                  zIndex: 0,
                  childConfig: this.definitionCongig,
                  onToggle: (e) => {
                    console.log(e);
                    this.definitionCongig.forEach((item) => {
                      item.selected = false;
                      if (item.functions == e.functions) {
                        item.selected = true;
                        this.mp.showToast("清晰度切换成功！");
                        //清晰度切换
                        // this.mp.reloadUrl('https://www.w3schools.com/html/movie.mp4');
                      }
                    });
                    // Action
                  },
                },
              ],
            })
          : {},
      ],
      custom: {
        rightSidebar: [
          {
            slot: "HD", // 对应定义的 slot 值
            width: "200px", // 侧栏宽度，string | number
          },
        ],
      },
    });
    // 添加 ready 事件监听
    this.mp.on("ready", () => {
      this.videoInfo = this.mp.video();
      // 将视频封面替换成课程设置的封面图
      this.videoInfo.poster = this.selectLearningInfo?.chapterResource?.videoCoverImg;
      this.videoInfo.addEventListener("play", this.handlerPlay);
      this.getMyCourseChapterProgress();
    });
    this.mp.on("error", (err) => {
      console.log("error", err);
      // this.mp.reset(); // 退回初始状态
      // this.mp.load(); // 重试加载
    });
    // // 音量调节时触发
    // this.mp.on('volume-change', (e) => {
    //   this.mp.video().volume = e.size;
    //   console.log(this.mp.on)
    // });
    // // 播放结束触发（此处判断用户是否选择连续播放，连续播放则继续播放下一条）
    // this.mp.on('ended', () => {
    //   this.mp.reloadUrl('https://www.w3schools.com/html/movie.mp4');
    // });
    // // 监听时间更新事件
    // this.mp.on('time-update', (event) => {
    //   // const currentTime = event.currentTime; // 当前播放时间（单位：秒）
    //   // const totalDuration = event.duration;   // 总时长
    //   console.log(event);

    //   // 判断是否达到目标时间点（例如30秒）
    //   // if (currentTime >= 10) {
    //   // this.mp.pause(); // 暂停视频
    //   // showCustomDialog(); // 调用自定义弹框
    //   // }
    // });
  },
  unmounted() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = "";
    }
    if (this.timeIntervalRecord) {
      clearInterval(this.timeIntervalRecord);
      this.timerInterval = "";
    }
  },
  methods: {
    // 获取章节阶段进度，用于定位到上次播放时间
    getMyCourseChapterProgress() {
      console.log(this.selectLearningInfo,111111111111)
      this.$Api.course
        .getMyCourseChapterProgress({
          schemeChapterPhaseId: this.selectLearningInfo?.id,
        })
        .then((res) => {
          this.watchedLastAt = res.data.data.watchedLastAt;
          if (this.watchedLastAt) {
            this.stageStartTime = this.watchedLastAt;
            this.videoInfo.currentTime = this.watchedLastAt;
            this.$forceUpdate();
          }
          // this.videoInfo.currentTime = 0;  // 可用于处理从上一次进度开始播放
          this.timeIntervalStart();
        });
    },
    // 监听播放事件，是否第一次播放，第一次播放添加定时器记录学习时间(每十秒上传一次)
    handlerPlay() {
      if (this.isFirstPlay) {
        this.timeIntervalRecord = setInterval(() => {
          this.recordVideoSegment();
        }, 10000);
        this.isFirstPlay = false;
      }
    },
    // 视频学习记录反馈
    recordVideoSegment(type) {
      // 必填参数为空不触发接口
      if (!this.selectLearningInfo.chapterResource?.resourceId) return;
      let params = {
        // courseId: this.selectLearningInfo?.chapterResource?.courseId,
        // chapterId: this.selectLearningInfo?.chapterResource?.chapterId,
        resourceId: this.selectLearningInfo.chapterResource?.resourceId,
        startSeconds: this.stageStartTime,
        endSeconds: type == "drag" ? this.lastVideoTime : this.videoInfo.currentTime,
      };
      // 结束时间一定要大于等于开始时间
      if (params.endSeconds < params.startSeconds) {
        return;
      }
      this.$Api.learning
        .recordVideoSegment(params)
        .then(() => {
          this.stageStartTime = this.videoInfo.currentTime;
          // 拖拽重启定时器
          if (type == "drag") {
            this.timeIntervalRecord = setInterval(() => {
              this.recordVideoSegment();
            }, 10000);
          }
        })
        .catch(() => {
          // 失败的情况下也要将时间重新做开始时间
          this.stageStartTime = this.videoInfo.currentTime;
        });
    },
    on_hd() {
      this.mp.toggleControls();

      //清晰度切换
      this.mp.reloadUrl("");

      this.mp.showToast("清晰度切换成功！");
    },
    getVideoQuestion(courseId, schemeId, roundId, phaseId, chapterId) {
      this.$Api.exam
        .videoQuestion(courseId, schemeId, roundId, phaseId, chapterId)
        .then((res) => {
          // 加个isShow属性判断是否展示过
          // this.videoQuestionList = res.data.data.map(item => {
          //   return { ...item, isShow: false }
          // });
          this.videoQuestionInfo = res.data.data;
          // 未配置弹题
          if (this.$Tools.empty(res.data.data) || !res.data.data.paperContext) {
            return;
          }
          res.data.data.paperContext.forEach((item) => {
            if (item.questions) {
              item.questions.forEach((sitem) => {
                // 此处加上判断,当为综合解答题的时候
                if (
                  sitem.questionTypeId == 99 ||
                  sitem.questionTypeId == 101 ||
                  sitem.questionTypeId == 102 ||
                  sitem.questionTypeId == 103
                ) {
                  sitem.questionContext.subQuestions.forEach((ssitem, ssindex) => {
                    ssitem.questionId = ssindex + 1;
                    ssitem.doAnswer = "";
                    ssitem.questionScore = 0;
                    ssitem.isCorrect = 2;
                  });
                }
                this.videoQuestionList.push({ ...sitem, isShow: false });
              });
            }
          });
        });
    },
    // 定时器监听弹题
    timeIntervalStart(flag) {
      this.videoInfo = this.mp.video();
      // 弹题关闭恢复播放
      if (this.videoInfo.paused && flag) {
        this.videoInfo.play();
      }
      this.timerInterval = setInterval(() => {
        // console.log(this.videoInfo.currentTime);  // 视频播放时间点（用于处理弹题逻辑）
        // 播放结束处理事件
        if (this.videoInfo.ended) {
          this.isFirstPlay = true;
          // 清除记录学习定时器
          this.recordVideoSegment(); // 先记录播放（未满10s的情况下）
          clearInterval(this.timeIntervalRecord);
          this.timeIntervalRecord = "";
          clearInterval(this.timerInterval);
          // 提示是否进入下一步骤（作业）
          // console.log("视频看完了");
          // 主动触发学习进度结算更新（仅视频观看完成后调用该接口）
          this.$Api.course
            .settlementVideoSegment({
              resourceId: this.selectLearningInfo?.chapterResource.resourceId,
              startSeconds: 0,
              endSeconds: 0,
            })
            .then(() => {
              // 查询当前章节进度
              this.$Api.course
                .getMyCourseChapterProgress({
                  schemeChapterPhaseId: this.selectLearningInfo.id,
                })
                .then((res) => {
                  if (res.data.data.inputStatus != 0) {
                    this.$emit("changePlayType", 4);
                  }
                });
            });

          // 处理是否连续播放(废弃)
          // if (this.iscontinuous) {
          //   let currentIndex = this.courseChapterList.findIndex(item => item.chapterId == this.selectLearningInfo?.chapterResource?.chapterId);
          //   // 当前播放是最后一个课程
          //   if (currentIndex == (this.courseChapterList.length - 1)) {
          //     this.$Dialog.toast("当前课程已看完");
          //   } else {
          //     // this.$store.commit('learning/setSelectLearningInfo', this.courseChapterList[currentIndex + 1]);
          //   }
          // }
          // 判断是否连续播放，连续播放切换下一个视频即改变selectLearningInfo
        }
        // 此处模拟做视频播放拖拽（当前时间小于上一次记录时间视为往前拖拽）
        // console.log(this.lastVideoTime)
        // console.log(this.videoInfo.currentTime)
        if (this.lastVideoTime - this.videoInfo.currentTime >= 2) {
          // console.log("拖拽了");
          // 记录并关闭定时器
          this.recordVideoSegment("drag");
          clearInterval(this.timeIntervalRecord);
          this.timeIntervalRecord = "";
        }
        // 此处模拟做视频播放拖拽（当前时间大于上一次记录时间超过2秒视为往后拖拽）
        else if (this.videoInfo.currentTime - this.lastVideoTime >= 2) {
          // console.log("拖拽了");
          // 记录并关闭定时器
          this.recordVideoSegment("drag");
          clearInterval(this.timeIntervalRecord);
          this.timeIntervalRecord = "";
        }
        this.lastVideoTime = this.videoInfo.currentTime;
        // 查找弹题数组中弹题时间是否与当前时间点相匹配，匹配到了暂停视频并弹题
        this.videoQuestionList.forEach((item) => {
          // 未设置弹题时间不显示
          if (!item.popupTime) return;
          let time = Math.abs(item.popupTime - this.videoInfo.currentTime);
          // 监听弹题数组查询播放到该事件需要展示的题目
          if (0 <= time && time <= 1) {
            // 判断是否展示过
            if (item.isShow) return;
            clearInterval(this.timerInterval);
            // 暂停并弹题
            this.videoInfo.pause();
            // item.questionContext = item.questionContext;
            item.answerTimeSection = this.$Tools.jsonDecode(item.answerTimeSection);
            this.$refs.videoQuestion.questionShow = true;
            this.$refs.videoQuestion.topicInfo = {
              ...item,
              doAnswer: "",
              showAnalysis: false,
              startTime: this.$Moment().format("YYYY-MM-DD HH:mm:ss"),
            }; // 新增用户填的答案字段doAnswer,是否显示解析showAnalysis
            item.isShow = true;
          }
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped></style>
